export default function PublishGuardrailCard({ preview }) {
    if (!preview || preview.qualityScore == null) return null;

    const score = preview.qualityScore;

    let level = "danger";
    let title = "Improve Before Publish";
    let message =
        "This website still has notable quality gaps. It is better to improve it before publishing.";

    if (score >= 85) {
        level = "success";
        title = "Ready to Publish";
        message =
            "This website passed the quality threshold strongly and looks ready for publish review.";
    } else if (score >= 70) {
        level = "warning";
        title = "Publish with Review";
        message =
            "This website is publishable, but a final review is recommended before going live.";
    }

    return (
        <div className={`wg-guardrail-card wg-guardrail-card--${level}`}>
            <div className="wg-guardrail-copy">
                <strong>{title}</strong>
                <p>{message}</p>
            </div>

            <div className="wg-guardrail-score">
                <span>Quality Score</span>
                <strong>{score}/100</strong>
            </div>
        </div>
    );
}